import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Connects to data-controller="espro-history"
export default class extends Controller {
  static targets = ["modal"];

  connect() {
    // Controller connected
  }

  async reprocess(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const url = button.dataset.reprocessUrl;
    if (!url) return;

    const originalHtml = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<i class="fa fa-spinner fa-spin me-1"></i> Processando...';

    try {
      const response = await post(url, {
        responseKind: "json",
      });

      if (response.ok) {
        button.innerHTML = '<i class="fa-solid fa-check me-1"></i> Reprocessado';
        button.classList.remove("btn-outline-danger");
        button.classList.add("btn-outline-success");
        this.openModal();
      } else {
        button.disabled = false;
        button.innerHTML = originalHtml;
        alert("Não foi possível reprocessar no momento. Tente novamente mais tarde.");
      }
    } catch (error) {
      console.error("Error reprocessing Espro:", error);
      button.disabled = false;
      button.innerHTML = originalHtml;
      alert("Erro ao enviar solicitação de reprocessamento.");
    }
  }

  openModal() {
    let modalEl = document.getElementById("espro-reprocess-modal");
    if (!modalEl) {
      const title = this.element.dataset.reprocessModalTitle || "Reprocessamento solicitado";
      const warning = this.element.dataset.reprocessModalWarning ||
        "A solicitação de reprocessamento foi enviada. Por favor, <strong>acesse o histórico dentro de alguns instantes para atualizar o histórico</strong>.";
      const understand = this.element.dataset.reprocessModalUnderstand || "Entendi";
      const close = this.element.dataset.reprocessModalClose || "Fechar";

      modalEl = document.createElement("div");
      modalEl.id = "espro-reprocess-modal";
      modalEl.className = "modal fade";
      modalEl.tabIndex = -1;
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.innerHTML = `
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content rounded-3 shadow">
            <div class="modal-header border-bottom-0 pb-0">
              <h5 class="modal-title fw-bold text-dark d-flex align-items-center gap-2">
                <i class="fa-solid fa-arrows-rotate text-primary"></i>
                ${title}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="${close}"></button>
            </div>
            <div class="modal-body py-3">
              <div class="alert alert-warning d-flex align-items-center gap-2 mb-0">
                <i class="fa-solid fa-triangle-exclamation fa-lg flex-shrink-0"></i>
                <div class="small">
                  ${warning}
                </div>
              </div>
            </div>
            <div class="modal-footer border-top-0 pt-0">
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                ${understand}
              </button>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(modalEl);
    }

    const ModalClass = window.bootstrap?.Modal || (typeof bootstrap !== "undefined" && bootstrap.Modal);
    if (!ModalClass) {
      alert("A solicitação de reprocessamento foi enviada.\n\nPor favor, acesse o histórico dentro de alguns instantes para atualizar o histórico.");
      return;
    }

    let bsModal = ModalClass.getInstance(modalEl);
    if (bsModal) {
      bsModal.dispose();
    }
    bsModal = new ModalClass(modalEl, { backdrop: "static", keyboard: true });
    bsModal.show();
  }
}
